// extracted by mini-css-extract-plugin
module.exports = {"Container":"OurTeamView-module--Container--1oGyE","Title":"OurTeamView-module--Title--3OGN-"};